export const TYCOON_AVATARS = Object.freeze([
  { id: 'fox', label: 'Cáo' },
  { id: 'panda', label: 'Gấu trúc' },
  { id: 'tiger', label: 'Hổ' },
  { id: 'penguin', label: 'Chim cánh cụt' },
  { id: 'owl', label: 'Cú mèo' },
  { id: 'koala', label: 'Koala' },
  { id: 'frog', label: 'Ếch' },
  { id: 'lion', label: 'Sư tử' }
]);

export const TYCOON_AVATAR_IDS = Object.freeze(TYCOON_AVATARS.map(item => item.id));
export const TYCOON_DEFAULT_AVATARS = Object.freeze(['fox', 'panda', 'tiger', 'penguin']);

const AVATAR_ID_SET = new Set(TYCOON_AVATAR_IDS);
const AVATAR_LABELS = Object.fromEntries(TYCOON_AVATARS.map(item => [item.id, item.label]));

export function isTycoonAvatarId(value) {
  return typeof value === 'string' && AVATAR_ID_SET.has(value);
}

export function defaultTycoonAvatarForSeat(index = 0) {
  const safeIndex = Math.max(0, Math.trunc(Number(index) || 0));
  return TYCOON_DEFAULT_AVATARS[safeIndex % TYCOON_DEFAULT_AVATARS.length];
}

export function normalizeTycoonAvatarId(value, fallbackIndex = 0) {
  return isTycoonAvatarId(value) ? value : defaultTycoonAvatarForSeat(fallbackIndex);
}

export function tycoonAvatarLabel(value, fallbackIndex = 0) {
  const id = normalizeTycoonAvatarId(value, fallbackIndex);
  return AVATAR_LABELS[id] || 'Nhân vật';
}
